import axios from 'axios';

// Get API URL from environment variable or auto-detect based on environment
const getApiUrl = () => {
    // If environment variable is set, use it
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    
    // Auto-detect production vs development
    if (process.env.NODE_ENV === 'production') {
        // Production: use same domain with /api
        return window.location.origin + '/api';
    }
    
    // Development: use localhost
    return 'http://31.97.203.163:5000/api';
};

const API_URL = getApiUrl();

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Export API_URL for use in other services
export { API_URL };

// Add token to requests if it exists
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;

